import React from "react";
import { withGlobalSettings } from "../../../hocs/withGlobalSettings";

const AffirmSnippet = ({ globalSettings }) => {
  const isAffirmFeatureEnabled = globalSettings?.feature_flag?.affirm || false;

  return isAffirmFeatureEnabled ? (
    <p>
      <b>Affirm:</b>
      {`{{AFFIRMSNIPPET}}`}{" "}
    </p>
  ) : (
    <></>
  );
};

export default withGlobalSettings(AffirmSnippet);
